export default __webpack_public_path__ + "static/media/job_offer3_m.c31cbb93.jpg";